import cm from 'classnames';

import { useAppSelector } from 'store/store-hooks';
import { IntroKeys } from 'components/app/intro/intro-keys';
import { Button } from 'components/UI/button/button';
import { Tooltip } from 'components/UI/tooltip/tooltip';
import { useCreateStory } from '../use-create-story';
import styles from './_placeholders.module.scss';

interface Props {
  cb: () => void;
}

export const PlaceholderStories = ({ cb }: Props) => {
  const stories = useAppSelector((state) => state.app__data.stories);
  const selectedProject = useAppSelector((state) => state.projects.selectedProject);
  const { createStoryDisabled, createStoryTooltip } = useCreateStory(false);

  if (!selectedProject || !stories || stories.length) return;
  return (
    <div className={styles.Placeholder}>
      <div className={styles.Placeholder__container}>
        <div className={styles.Placeholder__title}>There are no stories</div>
        <Tooltip tip={createStoryTooltip} showTooltip={createStoryDisabled} position="top">
          <Button
            onClick={cb}
            className={cm(styles.Placeholder__button)}
            data-intro={IntroKeys.createStory}
            disabled={createStoryDisabled}
          >
            Add Story
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
